import commonRes from '../abstract.resource';
import {readCity} from "../serializers/city.serializer";

const mod = angular.module('app.common.resources.city', [commonRes])

.factory('CityResource', (AbstractResource) => {
  class CityResource extends AbstractResource {
    constructor() {
      super('cities', CityResource.fromBackend, true);
    }

    /**
     * Parse a city retrieved from the backend.
     * @param {Object} o
     * @returns {City}
     */
    static fromBackend(o) {
      return readCity(o).makeImmutable();
    }
  }

  return new CityResource();
});

export default mod.name;
